import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1.5 text-xs text-foreground-500">
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <span key={`${item.label}-${i}`} className="flex items-center gap-1.5">
            {item.to && !isLast ? (
              <Link to={item.to} className="cursor-pointer transition-colors hover:text-primary-700">
                {item.label}
              </Link>
            ) : (
              <span className={isLast ? "text-foreground-800" : ""}>{item.label}</span>
            )}
            {!isLast && <i className="ri-arrow-right-s-line text-sm leading-none text-foreground-400" />}
          </span>
        );
      })}
    </nav>
  );
}